import { useState } from "react";
import { productImageUrl } from "@/utils/format.js";

const MAX_RETRIES = 3;

/**
 * Catalog/list thumbnail: lazy-loads and retries up to 3 times on failure so a burst of
 * concurrent /api/v1/files requests does not leave blank tiles forever.
 */
export default function ProductThumb({ fileId, alt = "", placeholder = "P", className = "" }) {
    const baseUrl = productImageUrl(fileId, { size: "thumb" });
    const [retryCount, setRetryCount] = useState(0);
    const [retryToken, setRetryToken] = useState(0);
    const [failed, setFailed] = useState(false);

    if (!baseUrl || failed) {
        return (
            <div className={`placeholder-image${className ? ` ${className}` : ""}`}>
                {placeholder}
            </div>
        );
    }

    const sep = baseUrl.includes("?") ? "&" : "?";
    const src = retryToken > 0 ? `${baseUrl}${sep}retry=${retryToken}` : baseUrl;

    return (
        <img
            className={className || undefined}
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            onError={() => {
                if (retryCount < MAX_RETRIES) {
                    setRetryCount((count) => count + 1);
                    setRetryToken(Date.now());
                    return;
                }
                setFailed(true);
            }}
        />
    );
}
